import { ComparerStatus } from '@/types/comparer';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Chip, IconButton, Stack, TableCell, TableRow, Typography } from '@mui/material';
import type { FC } from 'react';
import { statusColors } from '../comparerUtils/comparerUtils';

type StatusRowProps = {
  status: ComparerStatus;
  title: string | number;
  label: string;
  open?: boolean;
  setOpen?: (open: boolean) => void;
};

const StatusRow: FC<StatusRowProps> = ({ status, title, label, open, setOpen }) => {
  const cellColor = `${statusColors(status)}.main`;
  const isRemoved = status === 'removed';
  const isAdded = status === 'added';
  const expandable = setOpen !== undefined;

  return (
    <TableRow onClick={() => expandable && setOpen(!open)} sx={{ cursor: expandable ? 'pointer' : 'default' }}>
      <TableCell size='small' sx={{ pl: 8 }}>
        <Stack direction='row' gap={1} alignItems='center'>
          <IconButton size='small' sx={{ p: 0.25, visibility: expandable ? 'visible' : 'hidden' }}>
            {open ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
          </IconButton>
          <Chip label={status} color={statusColors(status)} size='small' />
          <Typography variant='caption' color='text.secondary'>
            {title}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell size='small' sx={{ color: isRemoved ? cellColor : 'text.primary' }}>
        {!isAdded ? label : '-'}
      </TableCell>
      <TableCell size='small' sx={{ color: isAdded ? cellColor : 'text.primary' }}>
        {!isRemoved ? label : '-'}
      </TableCell>
    </TableRow>
  );
};

export default StatusRow;
